import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';

function ProtectedRoute({ children }) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", backgroundColor: "#ffffff" }}>
        <div style={{ width: "36px", height: "36px", border: "3.5px solid #e0e0e0", borderTopColor: "#8EDC06", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
      </div>
    );
  }

  if (!auth.currentUser) {
    // Redirect unauthenticated user to login screen with return location saved
    return <Navigate to="/ride-login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;